import { render } from "./ParentPayment.vue?vue&type=template&id=6d2acfdc&scoped=true"
import script from "./ParentPayment.vue?vue&type=script&lang=js"
export * from "./ParentPayment.vue?vue&type=script&lang=js"

import "./ParentPayment.vue?vue&type=style&index=0&id=6d2acfdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2acfdc"]])

export default __exports__